import React from 'react';
import { Box, Container, Typography, Link, Grid, IconButton, Divider } from '@mui/material';
import { GitHub, Twitter, LinkedIn, Email } from '@mui/icons-material';

export const Footer: React.FC = () => {
  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'grey.50',
        borderTop: 1,
        borderColor: 'divider',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <Typography variant="h5" color="primary.main" gutterBottom sx={{ fontWeight: 'bold' }}>
              BnBCart
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 3, lineHeight: 1.6 }}>
              The complete solution for Bed & Breakfast owners. Manage properties, 
              track bookings, and grow your business with professional tools designed 
              specifically for hospitality professionals.
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                <Twitter />
              </IconButton>
              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                <LinkedIn />
              </IconButton>
              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                <GitHub />
              </IconButton>
              <IconButton size="small" sx={{ color: 'text.secondary' }}>
                <Email />
              </IconButton>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" color="text.primary" gutterBottom sx={{ fontWeight: 'bold' }}>
              Platform
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/dashboard" color="text.secondary" underline="hover" variant="body2">
                Dashboard
              </Link>
              <Link href="/listings" color="text.secondary" underline="hover" variant="body2">
                Manage Listings
              </Link>
              <Link href="/bookings" color="text.secondary" underline="hover" variant="body2">
                Track Bookings
              </Link>
              <Link href="/profile" color="text.secondary" underline="hover" variant="body2">
                Host Profile
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" color="text.primary" gutterBottom sx={{ fontWeight: 'bold' }}>
              Account
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="/auth/login" color="text.secondary" underline="hover" variant="body2">
                Sign In
              </Link>
              <Link href="/auth/register" color="text.secondary" underline="hover" variant="body2">
                Create Account
              </Link>
              <Link href="/auth/forgot-password" color="text.secondary" underline="hover" variant="body2">
                Reset Password
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" color="text.primary" gutterBottom sx={{ fontWeight: 'bold' }}>
              Resources
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Help Center
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Getting Started
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Best Practices
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                API Documentation
              </Link>
            </Box>
          </Grid>
          
          <Grid item xs={12} sm={6} md={2}>
            <Typography variant="h6" color="text.primary" gutterBottom sx={{ fontWeight: 'bold' }}>
              Company
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                About Us
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Privacy Policy
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Terms of Service
              </Link>
              <Link href="#" color="text.secondary" underline="hover" variant="body2">
                Contact Support
              </Link>
            </Box>
          </Grid>
        </Grid>
        
        <Divider sx={{ my: 4 }} />
        
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} BnBCart. All rights reserved. Built with ❤️ for hospitality professionals.
          </Typography>
          <Box sx={{ display: 'flex', gap: 3 }}>
            <Link href="#" color="text.secondary" underline="hover" variant="body2">
              Privacy
            </Link>
            <Link href="#" color="text.secondary" underline="hover" variant="body2">
              Terms
            </Link>
            <Link href="#" color="text.secondary" underline="hover" variant="body2">
              Cookies
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};